import { GameParticipantTypeSchema } from './shared'
import { z } from 'zod'

/** @deprecated historical will not be supported */
export const GameSeedingTypeSchema = z.enum(['standard', 'historical'])
export type GameSeedingType = z.infer<typeof GameSeedingTypeSchema>

const GameSettingsBaseSchema = z.object({
  timeBetweenRounds: z.number().gte(0).optional().describe('time between rounds for bracket games in days'),
  seedingType: GameSeedingTypeSchema.optional().describe(`standard: seed participants by a preliminary round`),
  bracketSize: z
    .number()
    .int()
    .min(2)
    .optional()
    .describe('The number of participants that should advance to the bracket rounds if seeding type is standard'),
})

export const GameScoringPatternSchema = z.enum(['sum', 'average'])
export type GameScoringPattern = z.infer<typeof GameScoringPatternSchema>

export const GroupGameSettingsSchema = z.object({
  ...GameSettingsBaseSchema.shape,
  participantType: GameParticipantTypeSchema.extract(['group']),
  scoringPattern: GameScoringPatternSchema,
  useInitialGroupSize: z.boolean().optional().describe('Whether to use the initial group size for average scoring'),
})
export type GroupGameSetting = z.infer<typeof GroupGameSettingsSchema>

export const UserGameSettingsSchema = z.object({
  ...GameSettingsBaseSchema.shape,
  participantType: GameParticipantTypeSchema.extract(['user']),
})
export type UserGameSetting = z.infer<typeof UserGameSettingsSchema>

export const GameSettingSchema = z.union([GroupGameSettingsSchema, UserGameSettingsSchema])
export type GameSetting = z.infer<typeof GameSettingSchema>
